import type { PrimaryEntity } from '../PageConfigProvider/types/chart';
import type { MetricValues } from '../PageConfigProvider/types/metric';

export type SubfilterTree = {
  id: string;
  name: string;
  children?: SubfilterTree[];
};

export type PageState = {
  activeTabId: string;
  selections: Record<string, SubfilterTree[]>;
  initialSelections: Record<string, SubfilterTree[]>;
  metricOverrides: Record<string, MetricValues>;
  primaryEntities: Record<string, PrimaryEntity>;
  multiPrimaryEntities: Record<string, PrimaryEntity[]>;
  /** Plot id marked when the user changes a per-chart header switcher. */
  chartSwitcherPlotId: string | null;
  subsidiaryDrill?: SubsidiaryDrill;
};

export type SubsidiaryDrill = {
  rcid: number;
  path: number[];
  color?: string;
};

/**
 * Compares two selection arrays to determine if they're equal.
 * Used to derive whether selections have been modified.
 */
const areSelectionsEqual = (
  a: SubfilterTree[] | undefined,
  b: SubfilterTree[] | undefined
): boolean => {
  if (!a && !b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  return JSON.stringify(a) === JSON.stringify(b);
};

/**
 * Derives whether selections have been modified by comparing
 * current selections to initial selections.
 */
export const haveSelectionsBeenModified = (
  pageState: PageState,
  plotId: string
): boolean => {
  const current = pageState.selections?.[plotId];
  const initial = pageState.initialSelections?.[plotId];
  return !areSelectionsEqual(current, initial);
};
